import { render, staticRenderFns } from "./DependencyList.vue?vue&type=template&id=17385614&scoped=true"
import script from "./DependencyList.vue?vue&type=script&lang=js"
export * from "./DependencyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17385614",
  null
  
)

export default component.exports